import React from "react";
import { Link } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";

function Footer() {
  const { theme } = useTheme();

  return (
    <footer
      className={`bg-gradient-to-r ${theme.gradient} p-6 text-white mt-4 shadow-inner`}
    >
      <div className="container mx-auto">
        <div className="grid md:grid-cols-3 gap-8 mb-4">
          <div>
            <h3 className="text-xl font-semibold mb-3 text-blue-200">
              Kontakt
            </h3>
            <p className="text-lg text-slate-200">Lisa Fuchsen</p>
            <p className="text-lg text-slate-200">
              Sozialpädagogin & Systemische Beraterin (SG)
            </p>
            <p className="text-lg text-slate-200">
              stepintochange.withlisa@gmail.com
            </p>
          </div>
          <div>
            <h3 className="text-xl font-semibold mb-3 text-blue-200">
              Walk & Talk
            </h3>
            <p className="text-lg text-slate-200">Beratung in der Natur</p>
            <p className="text-lg text-slate-200">Raum Wittlich</p>
          </div>
          <div>
            <h3 className="text-xl font-semibold mb-3 text-blue-200">
              Termine
            </h3>
            <p className="text-lg text-slate-200">Nach Vereinbarung</p>
            <p className="text-lg text-slate-200">
              Auch Online-Beratung möglich
            </p>
          </div>
        </div>
        <div className="text-center pt-4 border-t border-slate-600">
          <div className="flex justify-center space-x-6">
            <Link
              to="/privacy"
              className="text-slate-200 hover:text-white transition-colors"
            >
              Datenschutz
            </Link>
            <Link
              to="/imprint"
              className="text-slate-200 hover:text-white transition-colors"
            >
              Impressum
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
